import React from "react";
import {
  Container,
  Wrapper,
  Column,
  Video,
  TextBox,
  Title,
  Text,
} from "./styles";

export const VideoBox = ({ data, reverse }) => {
  return (
    <Container>
      <Wrapper reverse={reverse}>
        <Column>
          <Video src={data.video} muted loop autoPlay playsInline />
        </Column>
        <Column>
          <TextBox>
            <Title>{data.title}</Title>
            <Text>{data.text}</Text>
          </TextBox>
        </Column>
      </Wrapper>
    </Container>
  );
};
